import { jsx as e, jsxs as n } from "react/jsx-runtime";
import c from "classnames";
import l from "./index.es736.js";
import { CellAdditionalInfoWrapper as d } from "./index.es731.js";
import { BodyText as p } from "./index.es505.js";
const j = ({
  label: r,
  testId: o = "icon-cell",
  LeftIcon: t,
  RightIcon: i,
  gridDensity: s,
  additionalInfo: m
}) => {
  const a = c(l.iconCellRoot, l[s]);
  return /* @__PURE__ */ e("div", { className: a, "data-testid": o, children: /* @__PURE__ */ n(d, { ...m, children: [
    i,
    /* @__PURE__ */ e(p, { element: "p", isEllipsis: !0, "data-testid": o + "-label", children: r }),
    t
  ] }) });
};
export {
  j as IconCell
};
//# sourceMappingURL=index.es564.js.map
